import React from "react";
import LogoutIcon from "../Resources/svg/icon-logout.svg";
import {
  cleanTablePdf,
  cleanTablePdfRI,
  cleanConfigProduct
} from "../Store/secureInvestmentIncome/actions";
import {cleanAdviser}  from '../Store/adviser/actions';
import { logout } from "../Store/loginRedux/actions";
import { useDispatch } from "react-redux";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
import {storage} from '../Utils/storage';

const IconLogout = () => {
  const history = useHistory()
  const dispatch = useDispatch();
  const signOut = () => {
    window.open(process.env.REACT_APP_OAUTH2_LOGOUT);
    Auth.signOut({ global: true })
      .then(res => localStorage.clear())
      .catch(e => console.log(e));
  };

  const closeSession = async () => {
    await dispatch(logout());
    await dispatch(cleanTablePdf());
    await dispatch(cleanTablePdfRI());
    await dispatch(cleanConfigProduct());
    await dispatch(cleanAdviser());
    storage().removeItem('jwt');
    // localStorage.clear()
    history.push('/login');

    setTimeout(() => {
      signOut();
    }, 500);
  };
  return (
    <>
      <div className="nav-logout" onClick={closeSession}>
        <span>Cerrar Sesión</span>
        <img src={LogoutIcon} alt="icon2" />
      </div>
    </>
  );
};
export default IconLogout;
